import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../api-spec";

@Component({
    selector: "app-control-samples-no-evidence-api-manual",
    templateUrl: "../../api-spec.html",
    styleUrls: ["../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe]
})
export class ControlSamplesNoEvidenceApiManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: "Samples No Evidence API",
            httpMethod: "POST",
            path: "/controls/testing/advanced/effectiveness/automation/samples/{sampleGuid}/noevidence",

            parameters: [
                {
                    name: "sampleGuid",
                    in: "path",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "comment",
                    description: "Reason for no evidence.",
                    in: "query",
                    paramType: "string",
                    required: true,
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                    example: "Request has been successfully processed",
                },
            ],
        };
    }
}
